import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  const data = _taggedTemplateLiteral([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { Component, html } from 'lib/component';
import anime from 'animejs';
import slugify from 'slugify';
export default class Loader extends Component {
  init(options) {
    this.load(options.manifest, options.baseURL);
  }

  async load(manifest, baseURL) {
    let assets = new Map();
    let loaded = await Promise.all(manifest.map(url => fetch(url.indexOf('http') > -1 ? url : baseURL + url)));
    await Promise.all(loaded.map(async response => {
      let ext = response.url.split('.').pop();
      let id = response.url.split('/').pop();

      if (response.url.indexOf('/api/') > -1) {
        ext = 'json';
        id = response.url.split('/get/')[1].split('?')[0].toLowerCase();
      }

      switch (ext) {
        case 'mp4':
          let video = createVideo({
            src: response.url
          });
          return new Promise((resolve, reject) => {
            video.oncanplaythrough = function () {
              video.oncanplaythrough = null;
              resolve();
            };
          });
          break;

        case 'json':
          let json = await response.json();
          assets.set(id, json);
          return json;

        case 'jpg':
        case 'png':
          const image = new Image();
          assets.set(id, image);
          return new Promise(async (resolve, reject) => {
            image.addEventListener('load', function load() {
              image.removeEventListener('load', load);
              resolve(image);
            });
            image.addEventListener('error', function error() {
              image.removeEventListener('error', error);
              reject(image);
            });
            image.src = URL.createObjectURL((await response.blob()));
          });

        default:
          console.warn("[Loader] couldn't handle file ".concat(response.url));
          break;
      }
    })); // await new FontFaceObserver(fonts.light.replace(/"/g, '')).load()
    // if (window.location.search.indexOf('preview=true') > -1) {

    let content = {};
    let about = assets.get('about');
    let copy = assets.get('copy');
    content.work = this.parseWorks(assets.get('work'));
    content.logotype = copy.logotype;
    content.nav = [{
      "title": "Home",
      "url": ""
    }, {
      "title": "Campaigns",
      "url": "campaigns"
    }, {
      "title": "More",
      "url": "more"
    }, {
      "title": "About",
      "url": "about"
    }];
    content.nav[0].title = copy.navhome;
    content.nav[1].title = copy.navcampaigns;
    content.nav[2].title = copy.navmore;
    content.nav[3].title = copy.navabout;
    content.config = {
      viewCampaign: copy.viewcampaign,
      previous: copy.prev,
      next: copy.next,
      backToCampaigns: copy.backtocampaigns
    };
    content.about = {
      title: about.title,
      image: about.image.path,
      text: about.text,
      contact: about.contact,
      email: about.email
    };
    assets.set('content.json', content); // }

    this.assets = assets;
    this.dispatchEvent(new CustomEvent('complete', {
      detail: this.assets
    }));
  }

  parseWorks(data) {
    return data.entries.filter(work => work.published).sort((a, b) => {
      let dateA = new Date(a.date);
      let dateB = new Date(b.date);
      return dateB - dateA;
    }).map(work => {
      let slug = slugify(work.title).toLowerCase();
      let videos = [];

      for (let i = 0; i < 5; i++) {
        let url = work["video".concat(i + 1, "link")];
        if (!url.length) continue;
        let poster = work["video".concat(i + 1, "image")].path.replace(ENV.assetsURL.slice(1) + 'work/', '');
        let title = work["video".concat(i + 1, "title")];
        videos.push({
          url,
          title,
          poster
        });
      }

      return {
        slug,
        type: work.type.toLowerCase(),
        title: work.title,
        titleHome: work.homeTitle,
        poster: work.poster.path.replace(ENV.assetsURL.slice(1) + 'work/', ''),
        background: work.background.path.replace(ENV.assetsURL.slice(1) + 'work/', ''),
        videos
      };
    });
  }

  prependWorks(destination, origin) {
    destination.work = origin; // destination.work = origin.concat(destination.work)

    return destination;
  }

  render() {
    return html(_templateObject());
  }

  onRender() {}

  onResize(width, height) {}

  animateIn(params, complete) {
    this.classList.remove('u-hidden');
    anime({
      targets: this,
      opacity: [0, 1],
      duration: 400,
      complete
    });
  }

  animateOut(params, complete) {
    anime({
      targets: this,
      opacity: 0,
      duration: 400,
      complete
    });
  }

  onDestroy() {
    this.assets = null;
  }

}
customElements.define('rv-loader', Loader);